import React, { Component } from 'react';
import cn from 'classnames';
import styles from './Loading.scss';

export class LoadingSpinner extends Component {
  render(){
    const { className, size, ellipsis } = this.props;
    return (
      <i className={cn({
        [className]: true,
        [styles.ellipsis]: ellipsis,
        [styles.spinner]: !ellipsis,
        ['icon-spinner-xs']: size === 'xs',
        ['icon-spinner-lg']: size === 'lg',
        [styles.spinnerXs]: size === 'xs',
        [styles.spinnerLg]: size === 'lg',
      })}/>
    );
  }
}
